var React = require('react');

function External (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1,16a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.42L12.59,2H5A1,1,0,0,1,5,0H15a1,1,0,0,1,.38.08,1,1,0,0,1,.33.21,1,1,0,0,1,.21.33A1,1,0,0,1,16,1h0V11a1,1,0,0,1-2,0V3.41L1.71,15.71A1,1,0,0,1,1,16Z"}));
}

External.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = External;

External.default = External;
